import apiClient from './apiClient'

// Authenticated Receipts API (under /api/analytics). The public visitor beacons live separately in
// services/analytics/receipts.js — these are the owner-facing dashboard/report calls.

/** Pro-gated dashboard for a page over an optional date range (ISO yyyy-MM-dd). */
export async function getDashboard(pageId, { from, to } = {}) {
    const params = {}
    if (from) params.from = from
    if (to) params.to = to
    const { data } = await apiClient.get(`/analytics/pages/${pageId}`, { params })
    return data
}

/** Money-link tags on a page. */
export async function listMoneyLinks(pageId) {
    const { data } = await apiClient.get(`/analytics/pages/${pageId}/money-links`)
    return data
}

/** Tag (or retag) a link as monetized. moneyType: SHOP | AFFILIATE | SPONSOR | OTHER. */
export async function tagMoneyLink(linkButtonId, moneyType) {
    const { data } = await apiClient.put(`/analytics/money-links/${linkButtonId}`, { moneyType })
    return data
}

export async function untagMoneyLink(linkButtonId) {
    await apiClient.delete(`/analytics/money-links/${linkButtonId}`)
}

/** Generate a frozen sponsor report; returns its shareToken/shareUrl. */
export async function generateReport(body) {
    const { data } = await apiClient.post('/analytics/reports', body)
    return data
}

/** The caller's previous reports, newest first. */
export async function listReports() {
    const { data } = await apiClient.get('/analytics/reports')
    return data
}

export async function revokeReport(reportId) {
    await apiClient.post(`/analytics/reports/${reportId}/revoke`)
}

/** Public, anonymous report read (no auth) — used by the /r/{token} page. */
export async function getPublicReport(shareToken) {
    const { data } = await apiClient.get(`/reports/public/${shareToken}`)
    return data
}
